import { TaskRecord } from "@farmact/model/src/model/Order";
import { getTaskRecordTypeName, TaskRecordType } from "@farmact/model/src/model/services/TaskRecords";
import { getServicePriceUnitName } from "../../../../util/nameUtils/serviceNameUtils";
import * as Item from "../../../FaItem";
import { NumberInput } from "../../../inputs/NumberInput/NumberInput";

interface IOrderTaskRecordsModalContentProps {
    taskRecords: TaskRecord[];
    onTaskRecordsChange: (taskRecords: TaskRecord[]) => void;
}

export const OrderTaskRecordsModalContent = (props: IOrderTaskRecordsModalContentProps) => {
    const getTaskRecord = (taskRecordType: TaskRecordType): TaskRecord | null => {
        return (
            props.taskRecords.find(taskRecord => {
                return taskRecord.type === taskRecordType;
            }) ?? null
        );
    };

    const handleTaskRecordChange = (taskRecordId: TaskRecord["id"], value: number | null) => {
        props.onTaskRecordsChange(
            props.taskRecords.map(taskRecord => {
                if (taskRecord.id === taskRecordId) {
                    return {
                        ...taskRecord,
                        record: value,
                        timeStamp: new Date().toISOString(),
                    };
                }

                return taskRecord;
            })
        );
    };

    return (
        <div className="order-task-records-modal-content">
            {TASK_RECORDS.map(taskRecordType => {
                const taskRecord = getTaskRecord(taskRecordType);
                if (!taskRecord) {
                    return null;
                }

                return (
                    <Item.Root key={taskRecord.id}>
                        <Item.Label>{getTaskRecordTypeName(taskRecordType)}</Item.Label>
                        <Item.Content>
                            <NumberInput
                                placeholder={getTaskRecordTypeName(taskRecordType)}
                                step={0.1}
                                currentValue={taskRecord.record}
                                unit={getServicePriceUnitName(taskRecord.unit)}
                                onChange={value => {
                                    handleTaskRecordChange(taskRecord.id, value);
                                }}
                            />
                        </Item.Content>
                    </Item.Root>
                );
            })}
        </div>
    );
};

const TASK_RECORDS: TaskRecordType[] = [
    TaskRecordType.AREA,
    TaskRecordType.TRACKS,
    TaskRecordType.TONS,
    TaskRecordType.CUBIC_METERS,
    TaskRecordType.LITER,
];
